import {http} from './config';

export default {
    list:() => {
        return http.get('api/v1/tags-modelos/listar');
    },
}